// src/api/search.api.js
//
// Thin API client for the search domain.
// All network logic stays here — hooks consume these methods, never fetch directly.

import api from './axiosClient';

export const searchAPI = {
  /**
   * Instant autocomplete suggestions.
   * GET /api/v1/search/suggestions?q=<query>
   *
   * Response:
   *   { products: [...], categories: [...], suggestions: [...] }
   *
   * @param {string} q        - search prefix (min 2 chars)
   * @param {AbortSignal} signal - AbortController signal for cancellation
   */
  suggestions: (q, signal) =>
    api.get('/search/suggestions', { params: { q }, signal }),

  /**
   * Top searched keywords for the past 7 days.
   * GET /api/v1/search/trending
   *
   * Response: { trending: ["gold ring", "diamond earrings", ...] }
   */
  trending: () =>
    api.get('/search/trending'),
};